import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // Super Category
  getSuperCategoryListApiData,
  getSuperCategoryListApiSuccess,
  getSuperCategoryListApiFailed,
  addSuperCategoryApiData,
  addSuperCategoryApiSuccess,
  addSuperCategoryApiFailed,
  updateSuperCategoryApiData,
  updateSuperCategoryApiSuccess,
  updateSuperCategoryApiFailed,
  deleteSuperCategoryApiData,
  deleteSuperCategoryApiSuccess,
  deleteSuperCategoryApiFailed,
  toggleSuperCategoryStatusApiData,
  toggleSuperCategoryStatusApiSuccess,
  toggleSuperCategoryStatusApiFailed,

  // Category
  getCategoryListApiData,
  getCategoryListApiSuccess,
  getCategoryListApiFailed,
  addCategoryApiData,
  addCategoryApiSuccess,
  addCategoryApiFailed,
  updateCategoryApiData,
  updateCategoryApiSuccess,
  updateCategoryApiFailed,
  deleteCategoryApiData,
  deleteCategoryApiSuccess,
  deleteCategoryApiFailed,
  toggleCategoryStatusApiData,
  toggleCategoryStatusApiSuccess,
  toggleCategoryStatusApiFailed,

  // Sub Category
  getSubCategoryListApiData,
  getSubCategoryListApiSuccess,
  getSubCategoryListApiFailed,
  addSubCategoryApiData,
  addSubCategoryApiSuccess,
  addSubCategoryApiFailed,
  updateSubCategoryApiData,
  updateSubCategoryApiSuccess,
  updateSubCategoryApiFailed,
  deleteSubCategoryApiData,
  deleteSubCategoryApiSuccess,
  deleteSubCategoryApiFailed,
  toggleSubCategoryStatusApiData,
  toggleSubCategoryStatusApiSuccess,
  toggleSubCategoryStatusApiFailed,

  // Gig Profile (READ ONLY)
  getGigProfileListApiData,
  getGigProfileListApiSuccess,
  getGigProfileListApiFailed,
  getGigProfileDetailsApiData,
  getGigProfileDetailsApiSuccess,
  getGigProfileDetailsApiFailed,

  // ... existing exports ...
  getGigHireListApiData,
  getGigHireListApiSuccess,
  getGigHireListApiFailed,
} from './slice'

import { API } from '../../services'

// ================= Super Category =================
function* getSuperCategoryListApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.getGigSuperCategoryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getSuperCategoryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getSuperCategoryListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getSuperCategoryListApiFailed({ message: error?.message }))
  }
}

function* addSuperCategoryApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.addGigSuperCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addSuperCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(addSuperCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(addSuperCategoryApiFailed({ message: error?.message }))
  }
}

function* updateSuperCategoryApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.updateGigSuperCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateSuperCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateSuperCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateSuperCategoryApiFailed({ message: error?.message }))
  }
}

function* deleteSuperCategoryApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.deleteGigSuperCategory, payload)
    if (response?.data && response?.status === 200) {
      yield put(deleteSuperCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteSuperCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(deleteSuperCategoryApiFailed({ message: error?.message }))
  }
}

function* toggleSuperCategoryStatusApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.toggleGigSuperCategoryStatus, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(toggleSuperCategoryStatusApiSuccess({ payload: response?.data }))
    } else {
      yield put(toggleSuperCategoryStatusApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(toggleSuperCategoryStatusApiFailed({ message: error?.message }))
  }
}

// ================= Category =================
function* getCategoryListApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.getGigCategoryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getCategoryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getCategoryListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getCategoryListApiFailed({ message: error?.message }))
  }
}

function* addCategoryApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.addGigCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(addCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(addCategoryApiFailed({ message: error?.message }))
  }
}

function* updateCategoryApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.updateGigCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateCategoryApiFailed({ message: error?.message }))
  }
}

function* deleteCategoryApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.deleteGigCategory, payload)
    if (response?.data && response?.status === 200) {
      yield put(deleteCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(deleteCategoryApiFailed({ message: error?.message }))
  }
}

function* toggleCategoryStatusApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.toggleGigCategoryStatus, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(toggleCategoryStatusApiSuccess({ payload: response?.data }))
    } else {
      yield put(toggleCategoryStatusApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(toggleCategoryStatusApiFailed({ message: error?.message }))
  }
}

// ================= Sub Category =================
function* getSubCategoryListApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.getGigSubCategoryList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getSubCategoryListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getSubCategoryListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getSubCategoryListApiFailed({ message: error?.message }))
  }
}

function* addSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.addGigSubCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(addSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(addSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(addSubCategoryApiFailed({ message: error?.message }))
  }
}

function* updateSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.updateGigSubCategory, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(updateSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(updateSubCategoryApiFailed({ message: error?.message }))
  }
}

function* deleteSubCategoryApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.deleteGigSubCategory, payload)
    if (response?.data && response?.status === 200) {
      yield put(deleteSubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteSubCategoryApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(deleteSubCategoryApiFailed({ message: error?.message }))
  }
}

function* toggleSubCategoryStatusApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.toggleGigSubCategoryStatus, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(toggleSubCategoryStatusApiSuccess({ payload: response?.data }))
    } else {
      yield put(toggleSubCategoryStatusApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(toggleSubCategoryStatusApiFailed({ message: error?.message }))
  }
}

// ================= Gig Profile (READ ONLY) =================
function* getGigProfileListApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.getGigProfileList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getGigProfileListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getGigProfileListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getGigProfileListApiFailed({ message: error?.message }))
  }
}

function* getGigProfileDetailsApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.getGigProfileDetails, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getGigProfileDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getGigProfileDetailsApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getGigProfileDetailsApiFailed({ message: error?.message }))
  }
}

// ============== Gig Hire List (Application List) ==============
function* getGigHireListApi({ payload }) {
  try {
    const response = yield call(API.gigManagement.gigHireList, payload)
    if (response?.data && (response?.status === 200 || response?.status === 201)) {
      yield put(getGigHireListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getGigHireListApiFailed({ message: response?.message }))
    }
  } catch (error) {
    yield put(getGigHireListApiFailed({ message: error?.message }))
  }
}

/* ============================
      Root Saga
=============================== */
function* gigSaga() {
  // Super Category
  yield takeEvery(getSuperCategoryListApiData, getSuperCategoryListApi)
  yield takeEvery(addSuperCategoryApiData, addSuperCategoryApi)
  yield takeEvery(updateSuperCategoryApiData, updateSuperCategoryApi)
  yield takeEvery(deleteSuperCategoryApiData, deleteSuperCategoryApi)
  yield takeEvery(toggleSuperCategoryStatusApiData, toggleSuperCategoryStatusApi)

  // Category
  yield takeEvery(getCategoryListApiData, getCategoryListApi)
  yield takeEvery(addCategoryApiData, addCategoryApi)
  yield takeEvery(updateCategoryApiData, updateCategoryApi)
  yield takeEvery(deleteCategoryApiData, deleteCategoryApi)
  yield takeEvery(toggleCategoryStatusApiData, toggleCategoryStatusApi)

  // Sub Category
  yield takeEvery(getSubCategoryListApiData, getSubCategoryListApi)
  yield takeEvery(addSubCategoryApiData, addSubCategoryApi)
  yield takeEvery(updateSubCategoryApiData, updateSubCategoryApi)
  yield takeEvery(deleteSubCategoryApiData, deleteSubCategoryApi)
  yield takeEvery(toggleSubCategoryStatusApiData, toggleSubCategoryStatusApi)

  // Gig Profile (READ ONLY)
  yield takeEvery(getGigProfileListApiData, getGigProfileListApi)
  yield takeEvery(getGigProfileDetailsApiData, getGigProfileDetailsApi)
  yield takeEvery(getGigHireListApiData, getGigHireListApi)
}

export default gigSaga
